var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.95 8.734a4.98 4.98 0 001.425-3.484c0-2.757-2.243-5-5-5h-1.25c-2.757 0-5 2.243-5 5 0 1.355.546 2.583 1.425 3.484C1.314 9.644.5 11.102.5 12.75c0 2.757 2.243 5 5 5H8c2.757 0 5-2.243 5-5a4.98 4.98 0 00-2.05-4.016zM6.124 2.75h1.25c1.379 0 2.5 1.121 2.5 2.5 0 1.38-1.121 2.5-2.5 2.5h-1.25a2.502 2.502 0 01-2.5-2.5c0-1.379 1.121-2.5 2.5-2.5zM8 15.25H5.5a2.502 2.502 0 01-2.5-2.5c0-1.379 1.121-2.5 2.5-2.5H8c1.379 0 2.5 1.121 2.5 2.5s-1.121 2.5-2.5 2.5z",
    fill: "#00B9EF"
  })));
}

export default SvgEight;